import { authApiService } from '@/api/authApiService';
import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';

type DataType = {
  user_id: string;
};

export const assignDepositorApi = (wireId: string, data: DataType): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = `/organization/wires/${wireId}/depositor/assign/`;

  return authApiService.POST(uri, data);
};
